import { configureStore } from '@reduxjs/toolkit';
import partnerReducer from './partnerSlice';
import applicationsReducer from './applicationsSlice';

const store = configureStore({
  reducer: {
    partner: partnerReducer,
    applications: applicationsReducer,
  },
});

export default store; 